module.exports = __webpack_public_path__ + "static/media/bgimage_m.e98beb45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/revised/bgimage_m.png
// module id = 370
// module chunks = 0